import React, { useEffect, useState, useContext } from "react";

import GenderForm from './components/GenderForm';
import BirthdayForm from './components/BirthdayForm';
import EmailForm from './components/EmailForm';
import NameForm from './components/NameForm';
import PasswordForm from './components/PasswordForm';
import PromoStep from './components/PromoStep';
import { createPortal } from 'react-dom';
import { Footer } from './components/Footer';
import { getTTI, sendScreenResolution, simplyClick } from './helpers';
import modelOne from "./images/model1.png";
import modelTwo from "./images/model2.png";
import modelThree from "./images/model3.png";
import modelFour from "./images/model4.png";
import modeFive from "./images/model5.png";
import modelSix from "./images/model6.png";
import modelSeven from "./images/model7.png";
import PopUp from "./components/PopUp";
import { useSessionData } from "ui-components";
import { ContextProfileUser } from "./lib/profileContext";
import { landingId } from "./constants/index"

function App() {
  const [step, setStep] = useState(1);
  const footer = document.getElementById("footer");
  let content = null;
  const [showPopUp, setShowPopUp] = useState(false);
  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  const scrollToTop = (behavior = "auto") => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  };
  useEffect(() => {
    const supportsSR = "scrollRestoration" in window.history;
    const prevSR = supportsSR ? window.history.scrollRestoration : undefined;

    if (supportsSR) {
      window.history.scrollRestoration = "manual";
    }

    scrollToTop("auto");
    requestAnimationFrame(() => scrollToTop("auto"));
    setTimeout(() => scrollToTop("auto"), 0);

    const onLoad = () => scrollToTop("auto");
    window.addEventListener("load", onLoad);

    return () => {
      window.removeEventListener("load", onLoad);
      if (supportsSR) {
        window.history.scrollRestoration = prevSR ?? "auto";
      }
    };
  }, []);

  useEffect(() => {
    const images = [
      modelOne,
      modelTwo,
      modelThree,
      modelFour,
      modeFive,
      modelSix,
      modelSeven,
    ];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const openPopUp = (e) => {
    if (e.target === e.currentTarget) {
      setShowPopUp(true);
      simplyClick("cl_lnd_photos", { text: `step(${step})` })
    }
  };

  const closePopUp = () => {
    setShowPopUp(false);
  };

  useEffect(() => {
    const registerGoogleContainer = document.querySelector(".content__wrapper");

    if (registerGoogleContainer && !showPopUp) {
      registerGoogleContainer.addEventListener("click", openPopUp);
    }

    return () => {
      if (registerGoogleContainer) {
        registerGoogleContainer.removeEventListener("click", openPopUp);
      }
    };
  }, [showPopUp, step]);


  switch (step) {
    case 2:
      content = (
        <>
          <GenderForm nextStep={() => setStep(3)} />
        </>
      );
      break;

    case 3:
      content = (
        <>
          <BirthdayForm nextStep={() => setStep(4)} />
        </>
      );
      break;
    case 4:
      content = (
        <>
          <NameForm nextStep={() => setStep(5)} />
        </>
      );
      break;
    case 5:
      content = (
        <>
          <EmailForm nextStep={() => setStep(6)} />
        </>
      );
      break;
    case 6:
      content = (
        <>
          <PasswordForm nextStep={() => setStep(7)} />
        </>
      );
      break;
    default:
      content = (
        <>
          <PromoStep nextStep={() => setStep(2)} />
        </>
      );
      break;
  }

  return (
    <>
      {showPopUp &&
        createPortal(
          <PopUp step={step} closePopUp={closePopUp} />,
          document.getElementById("root")
        )}
      {content}
      {footer && createPortal(<Footer />, footer)}
    </>
  );
}

export default App;
